module.exports = __webpack_public_path__ + "img/kyousei2old.03d5f647.jpg";